import { render, staticRenderFns } from "./ContactPersonPreview.vue?vue&type=template&id=0232a172&"
import script from "./ContactPersonPreview.vue?vue&type=script&lang=ts&"
export * from "./ContactPersonPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports